import React from 'react'
import PropTypes from 'prop-types'
import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'
import Typography from '@mui/material/Typography'
import { BRAND, TEXT } from '../../theme/tokens'

/**
 * A small spinner with words, shown where a list, value or choice will be
 * while its request is in flight ("Loading holidays…"). Reads no longer
 * cover the screen, so without it a page showed its empty state ("No
 * holidays", zero counts, an empty select) until the answer arrived.
 *
 * Announced once as a status; the spinner itself is decoration.
 */
const InlineLoading = ({ label, justify = 'center', py = 3, size = 16 }) => (
    <Box
        role="status"
        sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: justify,
            gap: 1.25,
            py,
        }}
    >
        <CircularProgress
            size={size}
            aria-hidden
            sx={{ color: BRAND.orange, flexShrink: 0 }}
        />
        <Typography variant="body2" sx={{ color: TEXT.muted }}>
            {label}
        </Typography>
    </Box>
)

InlineLoading.propTypes = {
    label: PropTypes.string.isRequired,
    justify: PropTypes.oneOf(['center', 'flex-start', 'flex-end']),
    py: PropTypes.number,
    size: PropTypes.number,
}

export default InlineLoading
